import React from 'react'

const content = (props) => (
  <div id="content" className="content" style={{ height: '100%' }}>
    {props.children}
  </div>
)

export default content
